function uniqueJSON(data) {
    const variantCounts = {};
    data.forEach((item) => {
        const variantid = item.variantid;
        variantCounts[variantid] = (variantCounts[variantid] || 0) + 1;
    });
    const uniqueData = Object.keys(variantCounts).map((variantid) => {
        const quantity = variantCounts[variantid];
        const uniqueItem = data.find((item) => item.variantid === variantid);
        return { ...uniqueItem, quantity };
    });

    return uniqueData;
}

function sortJSON(data, key, orden) {
    return data.sort(function (a, b) {
        var x = a[key],
            y = b[key];

        if (orden === "asc") {
            return x < y ? -1 : x > y ? 1 : 0;
        }

        if (orden === "desc") {
            return x > y ? -1 : x < y ? 1 : 0;
        }
    });
}

function generate_hash(integers) {
    integers.sort((a, b) => a - b);
    const integer_str = integers.join("");
    return integer_str;
}

function formatCurrency(value) {
    return value.toLocaleString(`${Shopify.locale}-${Shopify.country}`, {
        style: "currency",
        currency: Shopify.currency.active,
    });
}

function makeDecimal(num) {
    return new Decimal(num).toFixed(2);
}

function sumNumbers(arrayNumbers) {
    return Number(
        arrayNumbers.reduce((total, number) => total + number, 0).toFixed(2)
    );
}

async function retryAddProduct(formData) {
    for (let attempt = 1; attempt <= 5; attempt++) {
        try {
            const response = await fetch(
                window.Shopify.routes.root + "cart/add.js",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            ).then((response) => {
                return response.json();
            });
            if (
                response &&
                response.items?.length === formData.items.length &&
                response.message === undefined
            ) {
                console.log(`Attempt ${attempt}: Request successful.`);
                return true;
            } else {
                console.log(`Attempt ${attempt}: Request failed. Retrying...`);
            }
        } catch (error) {
            console.log(`Attempt ${attempt}: Request failed. Retrying...`);
        }
    }
    return false;
}

async function removeFromCartByIndividualKey(key) {
    const individualKey = key;
    const cart = await fetch("/cart.json").then((res) => res.json());

    const itemKeys = cart.items.flatMap((item) => {
        if (
            (item.properties["_fatherbundleproduct"] ??
                item.properties["_individualkey"]) === individualKey
        ) {
            return item.key;
        }
    });

    const formData = { updates: {} };
    itemKeys.forEach((key) => {
        formData.updates[key] = 0;
    });
    const response = await fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }
    )
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.error("Error:", error);
        });
    return response ? true : false;
}

async function updateCartDrawer(open = true) {
    console.log("DRAWER");
    if (open) document.querySelector("#cart-icon-bubble").click();
    const parser = new DOMParser();
    const miniCartFetchResponse = await fetch("?section_id=mini-cart").then(
        (res) => res.text()
    );
    document.querySelector("#mini-cart").innerHTML = parser
        .parseFromString(miniCartFetchResponse, "text/html")
        .body.querySelector(".shopify-section").innerHTML;
    const indexFetchResponse = await fetch("/").then((res) => res.text());
    document.querySelector("#cart-icon-bubble").innerHTML = parser
        .parseFromString(indexFetchResponse, "text/html")
        .body.querySelector("#cart-icon-bubble").innerHTML;
}
